
import PhysicsWorld from "../loop/PhysicsWorld";
import Vector from "../Vector";
import TickingObject, { TickingObjectOptions } from "./TickingObject";

export type PhysicsObjectOptions = {
	world: PhysicsWorld,
} & TickingObjectOptions

export default class PhysicsObject<T, C> extends TickingObject<T, C> {
	velocity = new Vector(0, 0)
	world

	constructor({ world, ...rest }: PhysicsObjectOptions) {
		super(rest)

		this.world = world
	}

	tick(delta: number) {
		this.position.add(
			this.velocity.clone().multiplyScalar(delta)
		)
		this.velocity.multiplyScalar(1 - (this.world.friction * delta))

	}
}